import { CYCLE_OPTIONS, FREQUENCY_OPTIONS, REMEDY_OPTIONS } from '../../constants/adrData';

export default function CycleInfoSection({ form, errors, onChange }) {
  const selectedEffects = Array.isArray(form.sideEffects) ? form.sideEffects : [];

  return (
    <>
      <div className="form-section-label">Cycle Details</div>

      {selectedEffects.length === 0 ? (
        <p style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>
          No side effects selected.
        </p>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {selectedEffects.map((effect) => {
            const cycleDetails = form.sideEffectCycles?.[effect] || {};
            const cycleError = errors.sideEffectCycles?.[effect];

            return (
              <div
                key={effect}
                className="record-diagnosis"
                style={{ marginBottom: 0 }}
              >
                <div className="record-diagnosis-label">Side Effect</div>
                <div className="record-diagnosis-text" style={{ marginBottom: '10px' }}>
                  {effect}
                </div>

                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">
                      Which chemo cycle did the side effect appear in (કીમોથેરાપીના કયા સાયકલ દરમિયાન આડઅસર જોવા મળી) <span className="required">*</span>
                    </label>
                    <select
                      name="sideEffectCycle"
                      data-effect={effect}
                      value={cycleDetails.cycle || ''}
                      onChange={onChange}
                      className={`form-control${cycleError ? ' error' : ''}`}
                    >
                      <option value="">Select cycle</option>
                      {CYCLE_OPTIONS.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    {cycleError && <span className="form-error">⚠ {cycleError}</span>}
                  </div>

                  {cycleDetails.cycle === 'Other' && (
                    <div className="form-group">
                      <label className="form-label">
                        Enter cycle manually <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="sideEffectCycleOther"
                        data-effect={effect}
                        value={cycleDetails.other || ''}
                        onChange={onChange}
                        className={`form-control${cycleError ? ' error' : ''}`}
                        placeholder="e.g 6, 7, after 2nd cycle"
                      />
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    How many times? (આડઅસર કેટલી વખત થઈ?) <span className="required">*</span>
                  </label>
                  <select
                    name="sideEffectFrequency"
                    data-effect={effect}
                    value={cycleDetails.frequency || ''}
                    onChange={onChange}
                    className={`form-control${cycleError ? ' error' : ''}`}
                  >
                    <option value="">Select count</option>
                    {FREQUENCY_OPTIONS.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">
                      Remedies (આડઅસરની સારવાર) <span className="required">*</span>
                    </label>
                    <select
                      name="sideEffectRemedy"
                      data-effect={effect}
                      value={cycleDetails.remedy || ''}
                      onChange={onChange}
                      className={`form-control${cycleError ? ' error' : ''}`}
                    >
                      <option value="">Select remedy</option>
                      {REMEDY_OPTIONS.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>

                  {cycleDetails.remedy === 'Other (અન્ય)' && (
                    <div className="form-group">
                      <label className="form-label">
                        Please specify <span className="required">*</span>
                      </label>
                      <textarea
                        name="sideEffectRemedyOther"
                        data-effect={effect}
                        value={cycleDetails.remedyOther || ''}
                        onChange={onChange}
                        className={`form-control${cycleError ? ' error' : ''}`}
                        placeholder="Describe the remedy"
                        rows={2}
                      />
                    </div>
                  )}
                </div>

                <div className="form-group" style={{ marginTop: '16px' }}>
                  <label className="form-label">
                    After treatment, side effect reduced or stopped (સારવાર પછી આડઅસર ઓછી થઈ અથવા બંધ થઈ ગઈ) <span className="required">*</span>
                  </label>
                  <select
                    name="sideEffectReduced"
                    data-effect={effect}
                    value={cycleDetails.reduced || ''}
                    onChange={onChange}
                    className={`form-control${cycleError ? ' error' : ''}`}
                  >
                    <option value="">Select option</option>
                    <option value="Yes (હા)">Yes (હા)</option>
                    <option value="No (ના)">No (ના)</option>
                  </select>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
